import React, { useEffect, useState } from "react";
import Footer from "../../common_components/Footer";
import Header from "../../common_components/Header";
import banner from "../../assets/img/banner2x.webp";
import instaimg from "../../assets/img/instagram.png";
import facebookimg from "../../assets/img/facebook.png";
import linkedinimg from "../../assets/img/linkedin.png";
import twitterimg from "../../assets/img/twitter.png";
import youtubeimg from "../../assets/img/youtube.png";
import websiteImage from "../../assets/img/websiteImage.png";

import img1 from "../../assets/img/main-page 1.jpg";
import img2 from "../../assets/img/main-page 2.jpeg";
import img3 from "../../assets/img/main-page 3.jpeg";
import aos from "aos";
import InstagramFeed from "react-ig-feed";
import "react-ig-feed/dist/index.css";
import "aos/dist/aos.css";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "./Home.css";
import FrontPageCarousel from "./FrontPageCarousel";
import Testimonials from "./Testimonials";
import NewsEvents from "./NewsEvents";
import { getFirestore, doc, setDoc } from "firebase/firestore";
import uuid from "react-uuid";
import InstaFeed from "./InstaFeed";
import LinkedinFeed from "./LinkedinFeed";
import { Link } from "react-router-dom";
function Home() {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [message, setMessage] = useState("");
  const getEmail = (e) => {
    setEmail(e.target.value);
  };
  const getName = (e) => {
    setName(e.target.value);
  };
  const getMessage = (e) => {
    setMessage(e.target.value);
  };
  useEffect(() => {
    aos.init();
  });
  const sentMessage = (e) => {
    e.preventDefault();
    alert("Message sent successfully");
    const db = getFirestore();
    const uid = uuid();
    const MData = {
      Name: name,
      Uid: uid,
      Email: email,
      Message: message,
      Check: "false",
      Time: new Date().toLocaleString(),
      timestamp: new Date().getTime(),
    };
    console.log(MData);
    // db.collection("MessageForm/"+uid).add(MData);
    setDoc(doc(db, "MessageForm", uid), MData);
    setName("");
    setEmail("");
    setMessage("");
  };
  return (
    <React.Fragment>
      <Header></Header>
      
      <FrontPageCarousel></FrontPageCarousel>
      <div className="container section-main">
      <Link to="/about" data-aos="fade-right"> <div className="left-section img-fluid">
          <div className="message">Chancellor's Message</div>
        </div></Link>
       

        <a
          href="https://vitapaa.netlify.app/register"
          className="right-section banner"
          data-aos="fade-left"
        >
          <img src={banner} alt="Banner 1" className="img-fluid image-banner" />
        </a>
      </div>
      <div className="container page-content_2 reunite">
        <div className="section1" data-aos="fade-right"></div>
        <div className="section2" data-aos="fade-left">
          <h1>The Reunite Program</h1>
          <p>
            Hello everyone! Welcome to Alumni Connect, the official app of
            VIT-AP University Alumni Association. The VIT-AP University has had
            the proud privilege to have served as an incubation space for your
            promising young selves. As you bid farewell to us and embark on
            fresh adventures, we wish to help retain memories of this place that
            once constituted your training ground---your playing field. Alumni
            Connect hopes to function as a forum where all members of VIT-AP
            University Alumni Association can pick up where they left off,
            reconnect with peers and faculty, and continually renew their bond
            with their alma mater. Let’s Reconnect, Recreate and Represent
            VIT-AP in all its glory to scale further heights.
          </p>
          <p>
            <b>Connect</b> today
            <br />
            <b>Transform</b> tomorrow
            <br />
            it's not just our mission
            <br />
            it's our wish<b> for you</b>
          </p>
        </div>
      </div>
      <NewsEvents></NewsEvents>
      {/* <Testimonials></Testimonials> */}
      
      <div className="container">
        <h3>Follow us on Instagram</h3>
        <iframe src="https://widget.tagembed.com/52202?view" style={{width:"100%",height:"800px",overflow: "auto"}} frameBorder="0" allowtransparency="true"></iframe>
      </div> 
      {/* <div className="container">
        <h3>Follow us on LinkedIn</h3>
        <LinkedinFeed> </LinkedinFeed>
      </div> */}
      <div className="container contact-form">
        <div className="contact-input" data-aos="fade-right">
          <h3>Write a message</h3>
          <form id="MessageForm">
            <input
              type="text"
              className="form-control"
              placeholder="Name *"
              id="MsgName"
              onChange={getName}
              value={name}
            />
            <input
              type="text"
              className="form-control"
              placeholder="Email *"
              id="MsgEmail"
              onChange={getEmail}
              value={email}
            />
            <textarea
              name=""
              rows="7"
              className="form-control"
              placeholder="Message *"
              id="MsgMessage"
              onChange={getMessage}
              value={message}
            ></textarea>
            <input
              className="form-control submit"
              type="submit"
              onClick={sentMessage}
              value="SUBMIT"
            />
          </form>
        </div>

        {/* <div className="contact-social">
          <h3>Connect with us</h3>
          <div className="sbox instagram">
            <img src={instaimg} className="img-fluid" alt="instagram icon" />
            <p>Instagram</p>
          </div>
          <div className="sbox facebook">
            <img src={facebookimg} className="img-fluid" alt="Facebook icon" />
            <p>Facebook</p>
          </div>
          <div className="sbox linkedin">
            <img src={linkedinimg} className="img-fluid" alt="Linkedin Icon" />
            <p>Linked In</p>
          </div>
          <div className="sbox twitter">
            <img src={twitterimg} className="img-fluid" alt="twitter icon" />
            <p>Twitter</p>
          </div>
          <div className="sbox youtube">
            <img src={youtubeimg} className="img-fluid" alt="youtube icon" />
            <p>Youtube</p>
          </div>
        </div> */}

        <div className="contact-social" data-aos="fade-left">
          <h3>Connect with us</h3>

          <a href="https://vitapaa.netlify.app/" data-aos="zoom-out" data-aos-delay="200">
            <div className="sbox2 instagram">
              <img
                src={websiteImage}
                className="img-fluid"
                alt="instagram icon"
              />
              <p>Website</p>
            </div>
          </a>

          <a href="https://www.instagram.com/test_alumni/" data-aos="zoom-out" data-aos-delay="400">
            <div className="sbox instagram">
              <img src={instaimg} className="img-fluid" alt="instagram icon" />
              <p>Instagram</p>
            </div>
          </a>

          <a href="https://www.facebook.com/vitap.coordalumni" data-aos="zoom-out" data-aos-delay="600">
            <div className="sbox facebook">
              <img
                src={facebookimg}
                className="img-fluid"
                alt="Facebook icon"
              />
              <p>Facebook</p>
            </div>
          </a>

          <a href="https://www.linkedin.com/in/vitap-alumni-591849218/" data-aos="zoom-out" data-aos-delay="800">
            <div className="sbox linkedin">
              <img
                src={linkedinimg}
                className="img-fluid"
                alt="Linkedin Icon"
              />
              <p>Linked In</p>
            </div>
          </a>

          {/* <div className="sbox twitter">
						<img src={twitterimg} className="img-fluid" alt="twitter icon" />
						<p>Twitter</p>
					</div> */}
          <a href="https://www.youtube.com/c/VITAP" data-aos="zoom-out" data-aos-delay="1000">
            <div className="sbox youtube">
              <img src={youtubeimg} className="img-fluid" alt="youtube icon" />
              <p>Youtube</p>
            </div>
          </a>
        </div>
      </div>
      <Footer data-aos="zoom-in"></Footer>
    </React.Fragment>
  );
}
export default Home;
